import {
  Avatar,
  AvatarGroup,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Skeleton,
  Stack
} from '@mui/material';
import MaterialReactTable from 'material-react-table';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Authenticate,
  FailedLogs,
  GetAppRegistrations,
  GetShipmentById,
  MarkAsResolvedLog,
  Pickup,
  QuoteAndSchedule
} from '../../apis/Agency';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Cancel, ContentCopy, ErrorSharp, Download } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useSelector } from 'react-redux';
import { base_logo_url } from '../../apis/constants';
import NoLogo from '../../assets/carrier logos/No Logo.png';
import { ErrorToast, successToast } from '../../components/Toasts';
import debounce from 'lodash.debounce';
import CloseIcon from '@mui/icons-material/Close';
import {
  TextField,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import { ToastContainer } from 'react-toastify';
import AceEditor from 'react-ace';
import SearchIcon from '@mui/icons-material/Search';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/ext-beautify';
import { InputAdornment } from '@mui/material';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/ext-searchbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// Import all themes you want to use
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/theme-dracula';
import 'ace-builds/src-noconflict/theme-solarized_light';
import 'ace-builds/src-noconflict/theme-solarized_dark';
import 'ace-builds/src-noconflict/theme-cobalt';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

dayjs.extend(utc);
dayjs.extend(timezone);

const themes = [
  { name: 'Theme1', value: 'monokai' },
  { name: 'Theme2', value: 'github' },
  { name: 'Theme3', value: 'dracula' },
  { name: 'Theme4', value: 'solarized_light' },
  { name: 'Theme5', value: 'solarized_dark' },
  { name: 'Theme6', value: 'cobalt' }
];
const JsonEditorDialog = ({
  open,
  handleClose,
  initialJson,
  selectedRowData
}) => {
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);

  const [jsonValue, setJsonValue] = useState('');
  const [searchKey, setSearchKey] = useState('');
  const [pickupApiLoader, setPickupApiLoader] = useState(false);
  const [isJsonDialogOpen, setIsJsonDialogOpen] = useState(false);
  const [theme, setTheme] = useState('github');
  const editorRef = useRef(null);
  const handleSearch = () => {
    if (editorRef.current && searchKey.trim() !== '') {
      const editor = editorRef.current.editor;

      editor.findAll(searchKey, {
        wrap: true,
        caseSensitive: false,
        wholeWord: false,
        regExp: false
      });
    }
  };

  const handleSearchKeyDown = e => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };
  const history = useHistory();

  useEffect(() => {
    if (open) {
      try {
        // Parse if the initialJson is a string
        const parsedJson =
          typeof initialJson === 'string'
            ? JSON.parse(initialJson)
            : initialJson;

        // Beautify on load
        const beautified = JSON.stringify(parsedJson, null, 2);
        setJsonValue(beautified);
      } catch (err) {
        console.error('Invalid JSON:', err);
        setJsonValue(initialJson); // Fallback to raw input
      }
    }
  }, [open, initialJson]);

  // Beautify JSON
  const handleBeautify = () => {
    try {
      const parsed = JSON.parse(jsonValue);
      const beautified = JSON.stringify(parsed, null, 2); // 2-space indentation
      setJsonValue(beautified);
    } catch (err) {
      ErrorToast('Invalid JSON format. Please fix it before saving.');
    }
  };
  const handleReScheduleReq = (selectedRow, reqBody) => {
    try {
      const parsedJson = JSON.parse(jsonValue); // Parse the JSON from AceEditor
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      console.log('User Time Zone:', userTimeZone);

      // Convert PickupDate to user's time zone
      const pickupDate = dayjs
        .tz(parsedJson.PickupDate, userTimeZone)
        .startOf('day');

      // Current date in user's time zone
      const currentDate = dayjs().tz(userTimeZone).startOf('day');

      // Compare dates
      if (pickupDate < currentDate) {
        ErrorToast('Please update the PickupDate. It cannot be in the past.');
        return;
      } else {
        setPickupApiLoader(true);
        GetAppRegistrations(AgencyID)
          .then(res => {
            if (res.status === 200 && selectedRow.source === 'EXTERNAL') {
              const activeClient = res.data.data.find(item => item.active);
              const createdBy = activeClient?.createdBy;
              const clientId = activeClient?.clientId;
              const clientSecret = activeClient?.clientSecret;
              const body = {
                clientId: clientId,
                clientSecret: clientSecret,
                grantType: 'client_credientials',
                scope: createdBy
              };

              if (selectedRow.action === 'Quote And Schedule Pickup') {
                Authenticate(body)
                  .then(res => {
                    res.status === 200 &&
                      QuoteAndSchedule(jsonValue, res.data.token)
                        .then(res => {
                          res.status === 200 && setPickupApiLoader(false);
                          MarkAsResolvedLog(selectedRow.id)
                            .then(res => console.log(res, 'resloved response'))
                            .catch(err => console.log(err, 'failed err'));
                          successToast(
                            'Shipment has been Re-Booked Successfully!'
                          );

                          setIsJsonDialogOpen(false);
                          handleClose();
                          history.push({
                            pathname: '/manage-shipments',
                            state: { selectedTab: 'Booked' }
                          });
                        })
                        .catch(err => {
                          setPickupApiLoader(false);
                          console.log(err, 'Pickup Failuer Error_____>>>>>>');
                          ErrorToast(err?.response?.data?.reasonPhrase);
                        });
                    console.log(res, 'Auth Success Resp----->>>');
                  })
                  .catch(err => {
                    ErrorToast(err?.message);
                  });
              } else {
                Authenticate(body)
                  .then(res => {
                    res.status === 200 &&
                      Pickup(jsonValue, res.data.token)
                        .then(res => {
                          res.status === 200 && setPickupApiLoader(false);
                          MarkAsResolvedLog(selectedRow.id)
                            .then(res => console.log(res, 'resloved response'))
                            .catch(err => console.log(err, 'failed err'));
                          successToast(
                            'Shipment has been Re-Booked Successfully!'
                          );
                          setIsJsonDialogOpen(false);
                          handleClose();
                          history.push({
                            pathname: '/manage-shipments',
                            state: { selectedTab: 'Booked' }
                          });
                        })
                        .catch(err => {
                          setPickupApiLoader(false);
                          console.log(err, 'Pickup Failuer Error_____>>>>>>');
                          ErrorToast(err?.response?.data?.reasonPhrase);
                        });
                    console.log(res, 'Auth Success Resp----->>>');
                  })
                  .catch(err => {
                    ErrorToast(err?.message);
                  });
              }
            }
          })
          .catch(err => ErrorToast(err?.message));
        console.log('Saving JSON:', parsedJson);
      }
    } catch (error) {
      ErrorToast('Invalid JSON format. Please fix it before saving.');
    }
  };
  const handleThemeChange = e => {
    setTheme(e.target.value);
  };
  return (
    <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
      <DialogTitle>
        Update JSON according to failure case " {selectedRowData.message}"
      </DialogTitle>
      <DialogContent>
        <TextField
          label='Search ...'
          value={searchKey}
          onChange={e => setSearchKey(e.target.value)}
          onKeyDown={handleSearchKeyDown}
          fullWidth
          size='small'
          sx={{ mb: 1, mt: 2 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton onClick={handleSearch} size='small'>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        <div
          style={{
            marginBottom: '10px',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
          }}
        >
          <div>
            <label style={{ marginRight: '10px' }}>Change Theme:</label>
            <select value={theme} onChange={handleThemeChange}>
              {themes.map(t => (
                <option key={t.value} value={t.value}>
                  {t.name}
                </option>
              ))}
            </select>
          </div>
          <Button
            size='small'
            color='info'
            variant='contained'
            onClick={handleBeautify}
            sx={{
              ml: 1,
              fontSize: 12,
              height: 22,
              textTransform: 'capitalize',
              width: {
                xs: '100%',
                sm: 'auto'
              }
            }}
          >
            Beautify JSON
          </Button>
        </div>
        {pickupApiLoader ? (
          <Box sx={{ width: 'auto', height: '380px' }}>
            <Skeleton sx={{ ml: 4, height: 10, mb: 2, width: 250 }} />
            <Skeleton
              sx={{ ml: 4, height: 15, mb: 2, width: 100 }}
              animation='wave'
            />
            <Skeleton
              sx={{ ml: 4, height: 10, mb: 2, width: 200 }}
              animation={false}
            />
            <Skeleton sx={{ ml: 4, height: 10, mb: 2, width: 250 }} />

            <Skeleton
              sx={{ ml: 4, height: 15, mb: 2, width: 100 }}
              animation='wave'
            />
            <Skeleton
              sx={{ ml: 4, height: 10, mb: 2, width: 200 }}
              animation={false}
            />
            <Skeleton sx={{ ml: 4, height: 10, mb: 2, width: 250 }} />

            <Skeleton
              sx={{ ml: 4, height: 15, mb: 2, width: 100 }}
              animation='wave'
            />
            <Skeleton
              sx={{ ml: 4, height: 10, mb: 2, width: 200 }}
              animation={false}
            />
            <Skeleton sx={{ ml: 4, height: 10, mb: 2, width: 250 }} />

            <Skeleton
              sx={{ ml: 4, height: 15, mb: 2, width: 100 }}
              animation='wave'
            />
            <Skeleton
              sx={{ ml: 4, height: 10, mb: 2, width: 200 }}
              animation={false}
            />
            <Skeleton sx={{ ml: 4, height: 10, mb: 2, width: 250 }} />
          </Box>
        ) : (
          <AceEditor
            ref={editorRef}
            fontSize={14}
            mode='json'
            theme={theme}
            value={jsonValue}
            onChange={setJsonValue}
            name='json_editor'
            editorProps={{ $blockScrolling: true }}
            width='100%'
            height='50vh'
            setOptions={{ useWorker: false, tabSize: 2 }}
          />
        )}
        <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Button
            size='small'
            color='warning'
            variant='contained'
            onClick={handleClose}
            sx={{ mt: 2 }}
          >
            Cancel
          </Button>
          <Button
            size='small'
            color='success'
            variant='contained'
            onClick={() => handleReScheduleReq(selectedRowData)}
            sx={{ mt: 2, mr: 1, width: '140px' }}
          >
            {pickupApiLoader ? (
              <CircularProgress sx={{ color: 'white' }} size={25} />
            ) : (
              'Confirm Re-Book'
            )}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default function ViewLogos() {
  const history = useHistory();

  const [logsArray, setLogsArray] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogContent, setDialogContent] = useState('');
  const [dialogTitle, setDialogTitle] = useState('');
  const [selectedRowData, setSelectedRowData] = useState('');
  const [value, setValue] = React.useState(0);
  const [logsLoader, setLogsLoader] = useState(false);
  const [markAsResolveLoader, setMarkAsResolveLoader] = useState(false);
  const [markResolvConfirm, setMarkResolvConfirm] = useState(false);
  const [selectedRow, setSelectedRow] = useState('');
  const [exportAnchorEl, setExportAnchorEl] = useState(null); // Moved exportAnchorEl state here
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );

  const [userPermissionsArr, setUserPermissionsArr] = useState(null);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);

  // Export functions
  const exportToExcel = (data, filename = 'shipment-logs') => {
    if (!data || data.length === 0) {
      ErrorToast('No data to export');
      return;
    }

    const exportColumns = [
      { key: 'createdBy', header: 'User' },
      { key: 'modifiedBy', header: 'Modified By' },
      { key: 'shipmentType', header: 'Shipment Mode' },
      { key: 'carrier', header: 'Carrier' },
      { key: 'source', header: 'Request Source' },
      { key: 'logTime', header: 'Date' },
      { key: 'action', header: 'Action' },
      { key: 'message', header: 'Error Message' },
      { key: 'messageLog', header: 'Details' },
      { key: 'messageRequest', header: 'Request' }
    ];

    const exportData = data.map(row => {
      const exportRow = {};
      exportColumns.forEach(col => {
        let value = row[col.key] || '';
        if (typeof value === 'string') {
          value = value
            .replace(/,/g, ';')
            .replace(/\n/g, ' ')
            .replace(/\r/g, ' ');
        }
        exportRow[col.header] = value;
      });
      return exportRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Shipment Logs');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `${filename}_${dayjs().format('YYYY-MM-DD-HHmmss')}.xlsx`);

    successToast('Export completed successfully!');
  };

  const exportToCSV = (data, filename = 'shipment-logs') => {
    if (!data || data.length === 0) {
      ErrorToast('No data to export');
      return;
    }

    const exportColumns = [
      { key: 'createdBy', header: 'User' },
      { key: 'modifiedBy', header: 'Modified By' },
      { key: 'shipmentType', header: 'Shipment Mode' },
      { key: 'carrier', header: 'Carrier' },
      { key: 'source', header: 'Request Source' },
      { key: 'logTime', header: 'Date' },
      { key: 'action', header: 'Action' },
      { key: 'message', header: 'Error Message' }
    ];

    const exportData = data.map(row => {
      const exportRow = {};
      exportColumns.forEach(col => {
        let value = row[col.key] || '';
        if (typeof value === 'string') {
          value = value
            .replace(/,/g, ';')
            .replace(/\n/g, ' ')
            .replace(/\r/g, ' ');
        }
        exportRow[col.header] = value;
      });
      return exportRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Shipment Logs');
    XLSX.writeFile(
      workbook,
      `${filename}_${dayjs().format('YYYY-MM-DD-HHmmss')}.csv`
    );

    successToast('CSV Export completed successfully!');
  };

  // Handle export menu
  const handleExportClick = event => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };

  const handleExportExcel = () => {
    exportToExcel(logsArray, 'shipment-logs');
    handleExportClose();
  };

  const handleExportCSV = () => {
    exportToCSV(logsArray, 'shipment-logs');
    handleExportClose();
  };

  const mtransitTabColumns = useMemo(
    () => [
      {
        accessorKey: 'createdBy',
        id: 'createdBy',
        header: 'User',
        size: 50,
        filterFn: (row, colID, filterValue) => {
          return (
            row.original.createdBy
              ?.toLowerCase()
              .includes(filterValue.toLowerCase()) ||
            row.original.modifiedBy
              ?.toLowerCase()
              .includes(filterValue.toLowerCase())
          );
        },
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
            >
              <span>{renderedCellValue}</span>
              <span style={{ fontSize: '12px', color: 'gray' }}>
                {row.original.modifiedBy}
              </span>
            </Box>
          </>
        )
      },
      {
        accessorKey: 'shipmentType',
        id: 'shipmentType',
        header: 'Shipment Mode',
        size: 5,
        filterFn: (row, colID, filterValue) => {
          return row.original.shipmentType
            ?.toLowerCase()
            .includes(filterValue.toLowerCase());
        },
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
            </Box>
          </>
        )
      },
      {
        accessorKey: 'carrier',
        id: 'carrier',
        header: 'Carrier',
        size: 50,
        filterFn: (row, colID, filterValue) => {
          return row.original.carrier
            ?.toLowerCase()
            .includes(filterValue.toLowerCase());
        },
        Cell: ({ renderedCellValue, row }) => (
          <>
            {renderedCellValue && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <AvatarGroup sx={{}} spacing='small'>
                  <Avatar
                    src={
                      row.original.carrierLogo
                        ? base_logo_url + row.original.carrierLogo
                        : NoLogo
                    }
                  />
                </AvatarGroup>
                <span>{renderedCellValue}</span>
                <br />
              </Box>
            )}
          </>
        )
      },
      {
        accessorKey: 'source',
        id: 'source',
        header: 'Request Source',
        size: 50,
        filterFn: (row, colID, filterValue) => {
          return row.original.source
            ?.toLowerCase()
            .includes(filterValue.toLowerCase());
        },
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
              <br />
            </Box>
          </>
        )
      },
      {
        accessorKey: 'logTime',
        id: 'logTime',
        header: 'Date',
        size: 50,
        filterFn: (row, colID, filterValue) => {
          return row.original.logTime
            ?.toLowerCase()
            .includes(filterValue.toLowerCase());
        },
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
              <br />
            </Box>
          </>
        )
      },
      {
        accessorKey: 'action',
        id: 'action',
        header: 'Action',
        size: 100,
        filterFn: (row, colID, filterValue) => {
          return row.original.action
            ?.toLowerCase()
            .includes(filterValue.toLowerCase());
        },
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
              <br />
            </Box>
          </>
        )
      },
      {
        accessorKey: 'message',
        id: 'message',
        header: 'Error Message',
        size: 350,
        filterFn: (row, colID, filterValue) => {
          return row.original.message
            ?.toLowerCase()
            .includes(filterValue.toLowerCase());
        },
        Cell: ({ renderedCellValue, row, column }) => (
          <>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: 330
              }}
            >
              <span style={{ width: 270 }}>
                {renderedCellValue?.length > 40
                  ? `${renderedCellValue?.substring(0, 40)}...`
                  : renderedCellValue}
              </span>
              {renderedCellValue?.length > 40 && (
                <VisibilityIcon
                  sx={{ cursor: 'pointer', marginLeft: 1 }}
                  aria-describedby={id}
                  variant='contained'
                  onClick={e => {
                    setDialogContent(renderedCellValue);
                    setDialogTitle(column.id);
                    handleClick(e);
                  }}
                />
              )}
            </Box>
          </>
        )
      },
      {
        accessorKey: 'messageLog',
        id: 'messageLog',
        header: 'Details',
        size: 350,
        filterFn: (row, colID, filterValue) => {
          return row.original.messageLog
            ?.toLowerCase()
            .includes(filterValue.toLowerCase());
        },
        Cell: ({ renderedCellValue, row, column }) => (
          <>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: 330
              }}
            >
              <span>
                {renderedCellValue.length > 40
                  ? `${renderedCellValue.substring(0, 40)}...`
                  : renderedCellValue}
              </span>
              {renderedCellValue.length > 40 && (
                <VisibilityIcon
                  sx={{ cursor: 'pointer', marginLeft: 1 }}
                  aria-describedby={id}
                  variant='contained'
                  onClick={e => {
                    setDialogContent(renderedCellValue);
                    setDialogTitle(column.id);
                    handleClick(e);
                  }}
                />
              )}
            </Box>
          </>
        )
      },
      {
        accessorKey: 'messageRequest',
        id: 'messageRequest',
        header: 'Request',
        size: 350,
        enableClickToCopy: true,
        muiTableBodyCellCopyButtonProps: {
          fullWidth: true,
          startIcon: <ContentCopy />,
          sx: { justifyContent: 'flex-start' }
        },
        filterFn: (row, colID, filterValue) => {
          return row.original.messageRequest
            ?.toLowerCase()
            .includes(filterValue.toLowerCase());
        },
        Cell: ({ renderedCellValue, row, column }) => (
          <>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: 300
              }}
            >
              <span>
                {renderedCellValue.length > 40
                  ? `${renderedCellValue.substring(0, 40)}...`
                  : renderedCellValue}
              </span>
              {renderedCellValue.length > 40 && (
                <VisibilityIcon
                  sx={{ cursor: 'pointer', marginLeft: 1 }}
                  aria-describedby={id}
                  variant='contained'
                  onClick={e => {
                    setSelectedRowData(row.original);
                    setDialogContent(renderedCellValue);
                    setDialogTitle(column.id);
                    handleClick(e);
                  }}
                />
              )}
            </Box>
          </>
        )
      }
    ],
    []
  );

  const [tableColumns, setTableColumns] = useState(mtransitTabColumns);

  useEffect(() => {
    const filteredCarrierPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Logs'
    );
    setUserPermissionsArr(filteredCarrierPermissions);
  }, [userRolePermissions]);

  useEffect(() => {
    if (userPermissionsArr) {
      let filteredColumns = [...mtransitTabColumns];

      if (
        !userPermissionsArr.filter(permissions => permissions.level2).length &&
        !UserIsAdmin
      ) {
        filteredColumns = filteredColumns.filter(
          item => item.accessorKey !== 'messageLog'
        );
      }

      if (
        !userPermissionsArr.filter(permissions => permissions.level3).length &&
        !UserIsAdmin
      ) {
        filteredColumns = filteredColumns.filter(
          item => item.accessorKey !== 'messageRequest'
        );
      }

      setTableColumns(filteredColumns);
    }
  }, [userPermissionsArr]);

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setLogsLoader(true);
    FailedLogs()
      .then(res => {
        res.status === 200 && setLogsLoader(false);
        setLogsArray(res.data.data);
      })
      .catch(err => console.log(err, 'Failed Error'));
  }, []);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [isJsonDialogOpen, setIsJsonDialogOpen] = useState(false);
  const [editableJson, setEditableJson] = useState(
    JSON.stringify(selectedRowData.messageRequest)
  );
  const [jsonError, setJsonError] = useState('');

  // Open Dialog
  const handleOpenJsonDialog = selectedRow => {
    handleClose();
    setEditableJson(selectedRow.messageRequest);
    setIsJsonDialogOpen(true);
    setJsonError(''); // Clear errors
  };
  const inputRef = useRef();

  // Debounce to reduce frequent state updates
  const debouncedChangeHandler = debounce(value => {
    try {
      JSON.parse(value); // Validate JSON
      setJsonError('');
    } catch (err) {
      setJsonError('Invalid JSON');
    }
    setEditableJson(value);
  }, 10000); // Adjust delay as needed
  // Close Dialog
  const handleCloseJsonDialog = () => {
    setIsJsonDialogOpen(false);
  };

  // Beautify JSON
  const handleBeautifyJson = () => {
    try {
      const parsedJson = JSON.parse(editableJson);
      setEditableJson(JSON.stringify(parsedJson, null, 2));
      setJsonError(''); // Clear error if JSON is valid
    } catch (e) {
      setJsonError('Invalid JSON format');
    }
  };

  const handleConfirmMarkAsResolved = rowData => {
    setMarkResolvConfirm(true);
    setSelectedRow(rowData);
  };

  const handleMarkAsResolvedReq = () => {
    setMarkAsResolveLoader(true);
    MarkAsResolvedLog(selectedRow.original.id)
      .then(res => {
        setMarkResolvConfirm(false);
        res.status === 200 &&
          FailedLogs()
            .then(res => {
              res.status === 200 && setMarkAsResolveLoader(false);
              setLogsArray(res.data.data);
              successToast('Marked as resolved successfully!');
            })
            .catch(err => console.log(err, 'Failed Error'));
      })
      .catch(err => {
        setMarkAsResolveLoader(false);
        ErrorToast(err?.message);
      });
  };

  const handleReQuoteOrPickUp = row => {
    if (row.original.source === 'EXTERNAL') {
      setSelectedRowData(row.original);
      setDialogContent(row.original);
      setDialogTitle(row.original);
      handleOpenJsonDialog(row.original);
    } else {
      const rowData = JSON.parse(row.original.messageRequest);
      GetShipmentById(rowData.ShipmentId)
        .then(res => {
          res.status === 200 &&
            history.push({
              pathname: '/quick-quote',
              state: {
                pickupRowData: row.original.messageRequest,
                disptachOpen: 'Get Quote',
                rateType: 'Quick Quote',
                carrierApiNames: [],
                paymentType: '',
                locationId: row.original.id,
                userLocationsArr: [],
                shipmentMiles: '',
                origin: 'Logs',
                data: res.data.data
              }
            });
        })
        .catch(err => ErrorToast(err?.message));
    }
  };

  const handleCloseMarkResolved = () => {
    setMarkResolvConfirm(false);
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        mt: 1
      }}
    >
      {/* Dialog for detail/request/error eye icon */}
      <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
        <DialogTitle
          sx={{
            fontWeight: 700,
            textTransform: 'capitalize',
            borderBottom: '1px solid #e0e0e0',
            pb: 1
          }}
        >
          {dialogTitle}
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Box
            component='pre'
            sx={{
              m: 0,
              p: 2.5,
              bgcolor: '#f5f7fa',
              color: '#1a1a2e',
              fontFamily: '"Fira Code", "Cascadia Code", "Consolas", monospace',
              fontSize: 14,
              lineHeight: 1.7,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              overflowX: 'auto',
              minHeight: 120,
              maxHeight: '65vh',
              overflowY: 'auto',
              borderRadius: '0 0 4px 4px'
            }}
          >
            {(() => {
              const raw =
                typeof dialogContent === 'string'
                  ? dialogContent
                  : JSON.stringify(dialogContent, null, 2);
              try {
                return JSON.stringify(JSON.parse(raw), null, 2);
              } catch {
                return raw;
              }
            })()}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant='outlined' size='small'>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={markResolvConfirm}
        onClose={handleCloseMarkResolved}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        PaperProps={{
          sx: {
            width: {
              xs: '100%',
              sm: 'auto'
            },
            m: {
              xs: 1,
              sm: 2
            }
          }
        }}
      >
        <DialogTitle id='alert-dialog-title'>
          {'Do you confirm to Mark this shipment as Resolved?'}
        </DialogTitle>
        <DialogActions>
          <Button
            size='small'
            variant='outlined'
            onClick={handleCloseMarkResolved}
            color='warning'
          >
            Disagree
          </Button>
          <Button
            size='small'
            variant='contained'
            onClick={handleMarkAsResolvedReq}
            autoFocus
            color='success'
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
      <JsonEditorDialog
        open={isJsonDialogOpen}
        handleClose={handleCloseJsonDialog}
        initialJson={editableJson}
        selectedRowData={selectedRowData}
      />
      <ToastContainer
        style={{ width: 'auto' }}
        position='top-center'
        autoClose={7000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <MaterialReactTable
        enableRowActions
        enableStickyHeader
        renderRowActions={({ row }) => {
          return (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '230px'
              }}
            >
              {row.original.source !== '' && (
                <Button
                  color='info'
                  sx={{ fontSize: 12, textTransform: 'capitalize' }}
                  onClick={() => handleReQuoteOrPickUp(row)}
                  size='small'
                  variant='contained'
                >
                  Re-Book
                </Button>
              )}
              <Button
                onClick={() => handleConfirmMarkAsResolved(row)}
                color='success'
                sx={{
                  fontSize: 12,
                  width: '140px',
                  textTransform: 'capitalize',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
                size='small'
                variant='outlined'
              >
                {selectedRow.index === row.index && markAsResolveLoader ? (
                  <CircularProgress color='success' size={20} />
                ) : (
                  <div>
                    Mark as Resolved <CheckCircleIcon fontSize='small' />
                  </div>
                )}
              </Button>
            </Box>
          );
        }}
        renderTopToolbarCustomActions={() => {
          return (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'center'
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label='basic tabs example'
              >
                <Tab label='Shipments Logs' {...a11yProps(0)} />
              </Tabs>

              <Button
                variant='contained'
                color='primary'
                size='small'
                startIcon={<Download />}
                onClick={handleExportClick}
                sx={{ mr: 2 }}
              >
                Export
              </Button>

              <Menu
                anchorEl={exportAnchorEl}
                open={Boolean(exportAnchorEl)}
                onClose={handleExportClose}
              >
                <MenuItem onClick={handleExportExcel}>
                  <ListItemIcon>
                    <Download fontSize='small' />
                  </ListItemIcon>
                  <ListItemText>Export as Excel (.xlsx)</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleExportCSV}>
                  <ListItemIcon>
                    <Download fontSize='small' />
                  </ListItemIcon>
                  <ListItemText>Export as CSV (.csv)</ListItemText>
                </MenuItem>
              </Menu>
            </Box>
          );
        }}
        columns={tableColumns}
        data={logsArray}
        state={{
          isLoading: logsLoader
        }}
        initialState={{
          density: 'compact',
          isLoading: logsLoader
        }}
        muiTablePaperProps={{
          sx: { width: '100%', maxWidth: '100%', overflow: 'hidden' }
        }}
        muiTableContainerProps={{
          sx: { maxHeight: '70vh', minHeight: '70vh' }
        }}
      />
    </Box>
  );
}
